import { render, staticRenderFns } from "./CmgTwoStepVerificationLearnMoreModal.vue?vue&type=template&id=0270d83e&scoped=true&lang=pug&"
import script from "./cmg-two-step-verification-learn-more-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-two-step-verification-learn-more-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgTwoStepVerificationLearnMoreModal.vue?vue&type=style&index=0&id=0270d83e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0270d83e",
  null
  
)

export default component.exports